




















import Vue from 'vue';
import { defineComponent, computed, ref } from '@vue/composition-api';

const componentName = 'wok-panel-sub-menu';

export default defineComponent({
    name: componentName,

    props: {
        icon: {
            type: String,
            default: undefined
        },
        title: {
            type: String,
            required: true
        }
    },

    setup(props, context) {
        const subMenuActive = ref(false);

        const wrapperClasses = computed(() => {
            return {
                'wok--panel-sub-menu__wrapper': true,
                'wok--panel-sub-menu--active': subMenuActive.value
            }
        });

        const appropriateAccessory = computed(() => {
            if (subMenuActive.value) {
                return 'wok-icon-up-sm-16';
            }
            return 'wok-icon-down-sm-16';
        });

        return {
            subMenuActive,
            wrapperClasses,
            appropriateAccessory
        }
    }
})
